module.exports = __webpack_public_path__ + "img/qr-code.be80bb00.svg";